module.exports = __webpack_public_path__ + "img/banner-2024-10-03-1920x200.80f33aa0.gif";